import useMediaQuery from '@mui/material/useMediaQuery';
import dimensions from '@packages/shared/core/common/assets/styles/deprecated/vars.module.scss';

export function useResolution() {
  const mobile = useMediaQuery(`(max-width:${dimensions.maximalMobileWidth})`);

  return {
    isMobile: mobile,
    isDesktop: !mobile,
  };
}
